<template>
  <div class="student-edit">
    <div class="title">基本信息</div>
    <Form
      class="form"
      ref="form"
      :model="form"
      :rules="formRules"
      label-position="right"
      :label-width="120"
    >
      <FormItem label="学生名称：" prop="nickname">
        <Input v-model="form.nickname" clearable></Input>
      </FormItem>
      <FormItem label="学员手机号：" prop="mobile">
        <Input v-model="form.mobile" clearable></Input>
      </FormItem>
      <FormItem label="QQ：">
        <Input v-model="form.qq" clearable placeholder="请输入QQ号码" />
      </FormItem>
      <FormItem label="学员头像：" prop="avatar">
        <div class="upload-avatar-box">
          <div class="avatar" v-show="form.avatar">
            <img :src="form.avatar" />
          </div>
          <UploadFile
            url="/api/public/img"
            :format="['jpg','jpeg','png']"
            :primary="false"
            note="300*300像素或1:1，支持jpg、jpeg、png,小于5M"
            @onSuccess="onUploadSuccess"
          ></UploadFile>
        </div>
      </FormItem>
      <FormItem label="性别：" prop="sex">
        <Select v-model="form.sex">
          <Option v-for="item in sexData" :value="item.value" :key="item.value">{{item.label}}</Option>
        </Select>
      </FormItem>
      <FormItem label="出生日期：">
        <DatePicker
          type="date"
          placeholder="请选择"
          style="width:280px"
          :value="form.birthday"
          :editable ="false"
          @on-change="form.birthday=$event"
        ></DatePicker>
      </FormItem>
      <FormItem label="所在城市：">
        <AreaSelect
          :provinceId="form.province_id"
          :cityId="form.city_id"
          :districtId="form.district_id"
          @change="onChangeArea"
          style="width:500px;"
        ></AreaSelect>
      </FormItem>
      <AttrSelect form-url="/api/module/attribute/1" :attr="form.attr" @onChange="onAttrChange"></AttrSelect>
      <FormItem>
        <Button type="primary" size="large" style="width:100px;" @click="onSave">保存</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import AreaSelect from '@/components/AreaSelect'
import AttrSelect from '@/components/AttrSelect'
import UploadFile from '@/components/UploadFile'

export default {
  name: 'student-edit',
  components: {
    AreaSelect,
    AttrSelect,
    UploadFile
  },
  data() {
    return {
      form: {
        nickname: '',
        mobile: '',
        qq:'',
        avatar: '',
        sex: -1,
        birthday: '',
        province_id: 0,
        city_id: 0,
        district_id: 0,
        user_attr: '',
        attr: []
      },
      formRules: {
        nickname: [{ required: true, message: '学员姓名不能为空' }],
        mobile: [{ required: true, message: '学员手机号不能为空' }]
      },
      sexData: [{ value: 0, label: '男' }, { value: 1, label: '女' }],
      studentID: this.$route.query.id
    }
  },
  created() {
    if (this.studentID) {
      this.requestDetail()
    }
  },
  methods: {
    // on-event
    onUploadSuccess(data) {
      this.form.avatar = data.path
    },
    onAttrChange(val) {
      this.form.user_attr = val
    },
    onSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        if (this.studentID) {
          this.requestEdit()
        } else {
          this.requestAdd()
        }
      })
    },
    onChangeArea(obj) {
      this.form.province_id = obj.provinceId
      this.form.city_id = obj.cityId
      this.form.district_id = obj.districtId
    },
    // other
    // request
    requestAdd() {
      this.$http.post('/api/user', this.form).then(() => {
        this.$Message.success('保存成功')
        setTimeout(() => {
          this.$router.back()
        }, 1000)
      })
    },
    requestDetail() {
      this.$http.get('/api/user/' + this.studentID).then(data => {
        this.form = data
      })
    },
    requestEdit() {
      this.$http.put('/api/user/' + this.studentID, this.form).then(() => {
        this.$Message.success('保存成功')
        setTimeout(() => {
          this.$router.back()
        }, 1000)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.student-edit {
  .form {
    width: 500px;
  }
}
</style>
